import React, { useState } from "react";
import "./CourseTabs.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const CourseTabs = ({ description, numOfModules }) => {
  const [activeTab, setActiveTab] = useState("learn");

  const tabs = [
    { id: "learn", label: "What you'll learn" },
    { id: "includes", label: "Course includes" },
    { id: "description", label: "Description" },
  ];

  const content = {
    learn: [
      "Master fundamental concepts and advanced techniques to excel in your field",
      "Gain hands-on experience through real-world projects and case studies",
      "Learn to use industry-standard tools and technologies effectively",
      "Build critical thinking and problem-solving skills for modern challenges"
    ],
    includes: [
      `${numOfModules} modules`,
      "Quiz",
      "Certificate of completion",
    ],
  };

  return (
    <div className="course_includes_container">
      <div className="course_includes_tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`course_tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="course_tab_content">
        {activeTab === "learn" && (
          <ul>
            {content.learn.map((item, index) => (
              <li key={`learn-${index}`} className="course_tab_content_ul_item">
                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px', color: 'var(--nav-buttons-text)' }} />
                {item}
              </li>
            ))}
          </ul>
        )}

        {activeTab === "includes" && (
          <ul className="course_includes_child_container">
            {content.includes.map((item, index) => (
              <li key={`includes-${index}`}>
                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px', color: 'var(--nav-buttons-text)' }} />
                {item}
              </li>
            ))}
          </ul>
        )}

        {activeTab === "description" && (
          <p>{description}</p>
        )}
      </div>
    </div>
  );
};

export default CourseTabs;
